export default __webpack_public_path__ + "static/media/demand-by-bu-legend.43b664f4.svg";